import { IconReports } from '@components/Icons/Icons';
import { subNav } from '@components/Navbar/SubNav';

export const navId = 'subNavContentReports';
const links = [
  { title: "CDR's", href: '/reports/cdrs' },
  { title: 'Snapshot', href: '/reports/snapshot' },
];
const reportsSubNav = () =>
  subNav({
    id: navId,
    title: 'Reports',
    href: '/reports',
    icon: IconReports,
    links,
  });
export default reportsSubNav;
